import { render, staticRenderFns } from "./CapacitationsSchedules.vue?vue&type=template&id=58710508&"
import script from "./CapacitationsSchedules.vue?vue&type=script&lang=js&"
export * from "./CapacitationsSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports